import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { WarehouseTransferReason } from '../../entities/control-tables/warehouse-transfer-reason';



export class WarehouseTransferReasonRequest extends BaseRequest {
  warehouseTransferReason : WarehouseTransferReason;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.warehouseTransferReason = new WarehouseTransferReason();
  }
}